import namespace from '../../config/Namespace';

const types = {
  actions: {
    fetchTickets: 'fetchTickets',
    fetchTicketsSuccess: 'fetchTicketsSuccess',
    fetchTicketsDetails: 'fetchTicketsDetails',
    fetchTicketsDetailsSuccess: 'fetchTicketsDetailsSuccess',
    fetchTicketsTypesSuccess: 'fetchTicketsTypesSuccess',
  },
};

export default namespace('Tickets', types);
